/**
 * CetusEd Admin Console — Plan Management
 *
 * COMPLIANCE: Plan management controls district access to platform features.
 *   Changes to a district's plan are audit-logged with the actor's identity.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { usePlans } from '../../api/hooks';

export const PlanManagement: React.FC = () => {
  const { data: plans, isLoading, error } = usePlans();

  if (isLoading) return <div className="admin-loading">Loading plans...</div>;

  if (error) {
    return (
      <div className="admin-error" role="alert">
        Unable to load plans.
      </div>
    );
  }

  return (
    <div className="admin-page">
      <nav className="breadcrumb">
        <Link to="/billing">Billing</Link> / Plan Management
      </nav>

      <div className="page-header">
        <h1>Plan Management</h1>
      </div>

      <div className="plan-cards">
        {plans?.map((plan) => (
          <div key={plan.id} className="plan-card">
            <h2>{plan.name}</h2>
            <p className="plan-price">${plan.monthlyPrice}/mo</p>
            <p className="plan-description">{plan.description}</p>
            <ul className="plan-features">
              <li>{plan.storageIncluded} GB storage included</li>
              <li>Up to {plan.userLimit} users</li>
              {plan.features.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
